import React, { Component } from 'react'
import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import 'antd4/lib/grid/style/index.css'

import { Button, Input, DatePicker } from 'hljd'
import Styles from './style.module.less'
import store from '../store'
import { observer } from 'mobx-react'
import { toJS } from 'mobx'

const RangePicker = DatePicker.RangePicker
const Item = Form.Item

@observer
export default class extends Component {
  state = {
    expand: false
  }

  onChange = (date, dateString) => {}

  render() {
    let {
      wedding_time,
      sub_time,
      form: { phone, name, order_no }
    } = store
    return (
      <div className={Styles['order-search']}>
        <Form layout="inline">
          <Item label="客户手机" style={{ marginBottom: 10 }}>
            <Input
              placeholder=""
              onChange={store.getPhone}
              value={phone}
              style={{ width: 160 }}
            />
          </Item>
          <Item label="客户姓名">
            <Input
              placeholder=""
              onChange={store.getName}
              value={name}
              style={{ width: 160 }}
            />
          </Item>
          <Item label="推荐号">
            <Input
              placeholder=""
              onChange={store.getOrderNo}
              value={order_no}
              style={{ width: 260 }}
            />
          </Item>
          <Item label="婚宴时间">
            <RangePicker
              style={{ width: 280 }}
              value={toJS(wedding_time)}
              format="YYYY-MM-DD"
              onChange={store.getWtime}
            />
          </Item>
          <Item label="提交时间">
            <RangePicker
              style={{ width: 280 }}
              value={toJS(sub_time)}
              format="YYYY-MM-DD"
              onChange={store.getStime}
            />
          </Item>
          <Button type="primary" onClick={store.sendSearch}>
            查询
          </Button>
          <Button type="primary" onClick={store.sendRest}>
            重置
          </Button>
        </Form>
      </div>
    )
  }
}
